import { useState } from "react";
import { FaRobot, FaTimes, FaPhoneAlt } from "react-icons/fa";

const HelpCenter = () => {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    { type: "bot", text: "Hi 👋 How can I help you?" }
  ]);

  const options = [
    "Order Status",
    "Return Policy",
    "Payment Issue",
    "Talk to Support"
  ];

  const handleOptionClick = (option) => {
    let reply = "";

    switch (option) {
      case "Order Status":
        reply = "📦 You can track your order from 'My Orders' section.";
        break;
      case "Return Policy":
        reply = "🔁 We offer 7 days return policy on all products.";
        break;
      case "Payment Issue":
        reply = "💳 Please check your payment status or try again.";
        break;
      case "Talk to Support":
        reply = "📞 Click below to call our support team.";
        break;
      default:
        reply = "Sorry, I didn't understand.";
    }

    setMessages((prev) => [
      ...prev,
      { type: "user", text: option },
      { type: "bot", text: reply }
    ]);
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      
      {/* Page Content */}
      <h1 className="text-2xl font-bold mb-4">Help Center</h1>
      <p className="text-gray-600">
        Need help? Chat with us or explore common queries.
      </p>

      {/* Chat Button */}
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-5 right-5 bg-green-500 text-white p-4 rounded-full shadow-lg"
      >
        <FaRobot size={20} />
      </button>

      {/* Chatbot */}
      {open && (
        <div className="fixed bottom-20 right-5 w-[320px] bg-white rounded-xl shadow-lg flex flex-col">
          
          {/* Header */}
          <div className="bg-green-500 text-white p-3 flex justify-between items-center rounded-t-xl">
            <span>Support Chat</span>
            <FaTimes className="cursor-pointer" onClick={() => setOpen(false)} />
          </div>

          {/* Messages */}
          <div className="p-3 h-[300px] overflow-y-auto space-y-2">
            {messages.map((msg, i) => (
              <div
                key={i}
                className={`p-2 rounded-lg text-sm max-w-[80%] ${
                  msg.type === "bot"
                    ? "bg-gray-200 self-start"
                    : "bg-green-500 text-white self-end ml-auto"
                }`}
              >
                {msg.text}
              </div>
            ))}
          </div>

          {/* Options */}
          <div className="p-2 border-t space-y-2">
            {options.map((opt, i) => (
              <button
                key={i}
                onClick={() => handleOptionClick(opt)}
                className="w-full text-left px-3 py-2 bg-gray-100 rounded hover:bg-gray-200 text-sm"
              >
                {opt}
              </button>
            ))}

            {/* Call Now */}
            <a
              href="tel:9871238339"
              className="flex items-center justify-center gap-2 bg-green-500 text-white py-2 rounded"
            >
              <FaPhoneAlt /> Call Now
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default HelpCenter;